var map = {
	"./bg-img.jpeg": 997,
	"./dockbar/ic_github.png": 684,
	"./dockbar/ic_history.png": 9,
	"./dockbar/ic_profile.png": 202,
	"./dockbar/ic_profile_dark.png": 19,
	"./dockbar/ic_skill.png": 406,
	"./dockbar/ic_tstory.png": 754,
	"./logo/logo_bluebutton.png": 83,
	"./logo/logo_bluesale.png": 806,
	"./logo/logo_fairlink.webp": 575,
	"./logo/logo_redbutton.png": 446,
	"./logo/logo_tmember.svg": 79,
	"./profile/profile_photo.jpeg": 724,
	"./skills/ic_codex.png": 842,
	"./skills/ic_framermotion.png": 914,
	"./skills/ic_gemini.png": 946,
	"./skills/ic_next.png": 612,
	"./skills/ic_react.png": 898,
	"./skills/ic_reactquery.png": 920,
	"./skills/ic_styledcomponents.png": 858,
	"./skills/ic_tailwind.png": 399,
	"./skills/ic_windsurf.png": 261,
	"./skills/ic_zustand.svg": 852
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;